<template>
  <b-row>
    <b-col>
      <div class="row my-5 g-2">
        <block
          v-for="(anApp, i) in apps"
          :resource="anApp"
          :key="`tool-${i}`"
          @resource-clicked="handleResourceClick"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import config from "@/assets/_config.json";
import Block from "./block";

export default {
  name: "BlockResources",
  props: {
    apps: {
      type: Array,
      required: false,
      default: () => []
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      config
    };
  },
  components: {
    Block
  },
  methods: {
    handleResourceClick(resource) {
      this.$emit("resource-clicked", resource);
    }
  }
};
</script>
